<div *ngFor="let entrega of entregasList; let i = index" class="m-b">
  <div [attr.aria-expanded]="entrega?.isCollapsed">
    <div class="well well-lg card card-block card-header" [ngClass]="{'active': entrega?.isCollapsed}">
      <div class="col-10 name_indicador" (click)="entrega.isCollapsed = !entrega?.isCollapsed">
        {{entrega?.title}}
      </div>
    </div>
  </div>

  <div class="system-table table-container" [collapse]="!entrega?.isCollapsed" [isAnimated]="true">
    <div class="system-table-conteiner">
      <table>
        <thead>
          <tr>
            <th class="text-center">Código</th>
            <th>Entrega</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of entrega.entrega; let i = index">
            <tr>
              <td class="title text-center">{{ item?.issue_code }}</td>
              <td>{{ item?.issue_description }}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="text-center" *ngIf="entregasList?.length == 0">
  <h3>Nenhuma Entrega Vinculada ao {{entity?.title}}</h3>
</div>

<div class="hr-line-dashed"></div>
<div class="form-group row d-flex justify-content-end">
  <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
    <button class="btn btn-white" type="button" (click)="voltar()">Voltar</button>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>